import React, { useState, useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
// import Skeleton from 'react-loading-skeleton';
import { StyleRoot } from 'radium';

import './Extras.scss';
import FiltersList from '../FiltersList';
import PersonalizationContainer from '../../containers/PersonalizationContainer';
import NavigationBar from '../NavigationBar';
import Currency from '../Currency';
import bem from '../../utils/bem';
// import useIsTablet from '../useIsTablet';
import { ANIMATIONS } from '../../utils/constants';
import Selected from './SVG/Selected';
import Plus from '../Insurance/SVG/Plus';
import { capitalize } from '../../utils/helpers';
import ExtrasActualizar from './ExtrasActualizar';
import { useQuery } from '../../utils/hooks';
import Empty from './Empty';

const Accessory = ({ accessory, selectAccessory }) => (
  <button
    onClick={() => selectAccessory(accessory)}
    className={bem('accessory-button', { selected: accessory.isSelected })}
  >
    <span className="accessory">
      <div className="accessory__info">
        <div className="accessory__image-container">
          <img
            className="accessory__image"
            src={accessory.imagenUrl}
            alt={accessory.nombre}
          />
        </div>
        <div className="accessory__name">{capitalize(accessory.nombre)}{!!accessory.marca && ` - ${accessory.marca}`}</div>
        {/* <div className="accessory__description">{accessory.caracteristicas}</div> */}
      </div>
      <div className={bem('accessory__bottom', {
          'to-select': !accessory.isSelected
        })}>
        <div className="accessory__price">
          <Currency value={accessory.precioVenta} />
        </div>
        {accessory.isSelected ? (
          <Selected />
        ) : (
          <Plus />
        )}
      </div>
    </span>
    
  </button>
);

const AccessoryCombo = ({ accessory, selectAccessory }) => (
  <button
    onClick={() => selectAccessory(accessory)}
    className={bem('accessory-button', { selected: accessory.isSelected, 'combo': true })}
  >
    <span className="accessory">
      <div className="accessory__image-container">
          <img
            className="accessory__image"
            src={accessory.imagenUrl}
            alt={accessory.nombre}
          />
        </div>
      <div className="accessory__info">
        <div className="accessory__name">{capitalize(accessory.nombre)}</div>
        {/* <div className="accessory__description">{accessory.caracteristicas}</div> */}
        <div className="accessory__bottom">
          <div className="accessory__price">
            <Currency value={accessory.precioVenta} />
          </div>
          {accessory.isSelected ? (
            <Selected />
          ) : (
            <Plus />
          )}
        </div>
      </div>
    </span>
    
  </button>
);

const ExtrasList = ({ type, accessories, selectAccessory }) => {
  return (
  <div className="extras-list">
    <div className="extras-list__selected-filter">
      <span className="extras-list__selected-filter-text">{type}</span>
    </div>
    <p className="extras__disclaimer">Imágenes con fines ilustrativos</p>
    <div className={bem('extras-list__accessories', {
      [type.toLowerCase()]: true 
    })} style={ANIMATIONS.fadeIn}>
      {accessories.map(accessory => (
        type.toLowerCase().indexOf('combo') === -1 ?
        (
          <Accessory
            accessory={accessory}
            selectAccessory={selectAccessory}
          />
          ) : (
          <AccessoryCombo
            accessory={accessory}
            selectAccessory={selectAccessory}
          />  
        )
      ))}
    </div>
  </div>
)
};

// const ExtrasSkeleton = ({ isTablet }) => (
//   <div className="extras-skeleton">
//     <div className="extras-skeleton__row">
//       <div className="extras-skeleton__bone">
//         <Skeleton count={1} height={262} />
//       </div>
//       <div className="extras-skeleton__bone">
//         <Skeleton count={1} height={262} />
//       </div>
//       {!isTablet && (
//         <>
//           <div className="extras-skeleton__bone">
//             <Skeleton count={1} height={262} />
//           </div>
//           <div className="extras-skeleton__bone">
//             <Skeleton count={1} height={262} />
//           </div>
//         </>
//       )}
//     </div>
//     <div className="extras-skeleton__row">
//       <div className="extras-skeleton__bone">
//         <Skeleton count={1} height={262} />
//       </div>
//       <div className="extras-skeleton__bone">
//         <Skeleton count={1} height={262} />
//       </div>
//       {!isTablet && (
//         <>
//           <div className="extras-skeleton__bone">
//             <Skeleton count={1} height={262} />
//           </div>
//           <div className="extras-skeleton__bone">
//             <Skeleton count={1} height={262} />
//           </div>
//         </>
//       )}
//     </div>
//   </div>
// );

const Extras = ({ extras, selectAccessory }) => {
  const query = useQuery();
  const type = query.get('cat');

  const todosItem = {
    label: "Todos",
    value: "todos"
  };
  const { tipo, modelo, color, version, anio } = useParams();
  const accessories = extras?.data?.accessories || {};
  const isEmpty = !extras.isLoading && extras.isReady && Object.keys(accessories).length === 0;

  const filtersOptions = useMemo(
    () =>
      [{
        label: "Todos",
        value: "todos"
      }].concat(Object.keys(accessories).map(accessory => ({
        label: accessory,
        value: accessory,
      }))),
    [accessories]
  );
  const [selectedFilters, setSelectedFilters] = useState(() => {
    return type ? {
      label: type,
      value: type
    } : todosItem;
  });
  // const isTablet = useIsTablet();

  const filterChange = useCallback(
    selected => {
      if (selected.value === 'todos') {
        setSelectedFilters(todosItem);
        return;
      }
      var finding = Object.keys(accessories)
        .find(accessory => accessory === selected.value);

      setSelectedFilters(
        { label: finding, value: finding }
      );
    },
    [accessories, todosItem]
  );

  return (
    <div className="extras">
      <div className="extras__personalization">
        <PersonalizationContainer
          title="Escoge tus Accesorios"
          subTitle="Nada mejor que recibir tu carro nuevo, del color que más va con vos. No lo pensés más y ordená tus accesorios de una vez."
        >
          <div className="extras__navigation">
            <NavigationBar
              back={`/${tipo}/${modelo}/${version}/${anio}/`}
              next={`/${tipo}/${modelo}/${version}/${anio}/${color}/mantenimientos/`}
            />
          </div>
          <div className="extras__extras-content">
            <div className="title-wrapper">
              <h6 className="title-button">NUESTROS ACCESORIOS</h6>
            </div>
            {!isEmpty && <div className="extras-list">
              <StyleRoot>
                <div style={ANIMATIONS.fadeIn}>
                  <FiltersList
                    options={filtersOptions}
                    selected={selectedFilters}
                    onChange={filterChange}
                  />
                </div>
              </StyleRoot>
            </div>}
            {isEmpty && <Empty message={"En este momento no tenemos accesorios para este vehículo"} />}
            {!extras.isLoading && !isEmpty && (
              <StyleRoot>
                <div className="extras-all" style={ANIMATIONS.fadeIn}>
                  {selectedFilters.value !== 'todos'
                      ? <ExtrasList
                          key={selectedFilters.value}
                          type={selectedFilters.label}
                          accessories={accessories[selectedFilters?.value] || []}
                          selectAccessory={selectAccessory}
                        />
                      : Object.keys(accessories).map(key => (
                          <ExtrasList
                            key={key}
                            type={key}
                            accessories={accessories[key]}
                            selectAccessory={selectAccessory}
                          />
                        ))}
                </div>
              </StyleRoot>
            )}
            
            {/* <div className="extras__filters">
              {extras.isLoading ? (
                <Skeleton count={4} height={50} />
              ) : (
                <StyleRoot>
                  <div style={ANIMATIONS.fadeIn}>
                    <FiltersList
                      options={filtersOptions}
                      selected={selectedFilters}
                      onChange={filterChange}
                    />
                  </div>
                </StyleRoot>
              )}
            </div> */}
            {/* {extras.isLoading ? (
              <div className="extras__skeleton">
                <ExtrasSkeleton isTablet={isTablet} />
              </div>
            ) : (
              <div className="extras__extras-list">
                <h6 className="extras__title">NUESTROS ACCESORIOS</h6>
                {selectedFilters.length
                  ? selectedFilters.map(selectedFilter => (
                      <ExtrasList
                        key={selectedFilter.value}
                        type={selectedFilter.label}
                        accessories={accessories[selectedFilter?.value]}
                        selectAccessory={selectAccessory}
                      />
                    ))
                  : Object.keys(accessories).map(key => (
                      <ExtrasList
                        key={key}
                        type={key}
                        accessories={accessories[key]}
                        selectAccessory={selectAccessory}
                      />
                    ))}
              </div>
            )} */}
            <ExtrasActualizar type={type} tipo={tipo} modelo={modelo} version={version} anio={anio} color={color} />
          </div>
          <div className="extras__navigation">
            <NavigationBar
              back={`/${tipo}/${modelo}/${version}/${anio}/`}
              next={`/${tipo}/${modelo}/${version}/${anio}/${color}/mantenimientos/`}
            />
          </div>
        </PersonalizationContainer>
      </div>
    </div>
  );
};

export default Extras;
